export const attributes = {
  about: "About",
  projects: "Projects",
  contact: "Contact",
};
